import {
    Component,
    EventEmitter,
    Input,
    OnDestroy,
    OnInit,
    Output
} from "@angular/core";
import { Router } from "@angular/router";
import { ProFunnelModel } from "../../../../model/builk/profunnel/profunnel.model";
import { ProFunnelService } from "../../../../service/api/builk/profunnel.service";
import { ISubscription } from "rxjs/Subscription";

@Component({
    selector: "bo-builk-profunnel-refresh",
    templateUrl: "./profunnel-refresh.component.html",
    styleUrls: ["./profunnel-refresh.component.scss"]
})
export class ProFunnelRefreshComponent implements OnInit, OnDestroy {
    @Input() rowData: ProFunnelModel;
    @Output() readonly setProFunnelList = new EventEmitter<ProFunnelModel>();

    constructor(
        public router: Router,
        public proFunnelService: ProFunnelService
    ) {
    }
    proFunnelDetail: ProFunnelModel = new ProFunnelModel();
    subscription: ISubscription;

    ngOnInit(): void {
    }

    refreshProFunnel(id: number): void {
        this.proFunnelDetail.id = id;
        this.subscription = this.proFunnelService.updateProFunnelBackOffice(this.proFunnelDetail)
        .subscribe(
          Response => {
              if (Response) {
                    this.setProFunnelList.emit(Response);
              }
          },
          err => {
            // error
          }
        );
    }

    ngOnDestroy(): void {
        if (this.subscription) {
          this.subscription.unsubscribe();
        }
    }
}
